import { RequestForMovementRequest } from "../../libs/core-api-requests/documents/requestForMovementRequest"
import { ICureFormByStoreDTO, IDosageByStoreDTO, INFvByStoreDTO, IRequestForMovementCreateDTO, IRequestForMovementEditDTO, IRequestForMovementGetDTO, IRequestForMovementViewDTO } from "../../libs/coreapi-dto/documents/requestForMovement"
import { IRequestForMovementItemGetDTO, IRequestForMovementItemViewDTO } from "../../libs/coreapi-dto/documents/requestForMovementItem"
import CoreApiService from "../../system/api/coreApiService"
import { DocumentDataProviderV2 } from "./Common/DocumentDataProviderV2"

export class RequestForMovementDataProvider extends DocumentDataProviderV2<
    IRequestForMovementCreateDTO,
    IRequestForMovementGetDTO,
    IRequestForMovementEditDTO,
    IRequestForMovementViewDTO,
    IRequestForMovementItemViewDTO,
    IRequestForMovementItemGetDTO
> {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService;
    }
    
    getDataRequest(): Promise<RequestForMovementRequest> {
        return this._coreApiService.requestForMovementRequest;
    }

    getDistinctCureFormViewByStore(filter: IViewBody, callback?: (data: ICureFormByStoreDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
            this._coreApiService.requestForMovementRequest
                .then(r => r
                    .getDistinctCureFormViewByStore(filter, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e.data.entities, e.data.totalCount);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        else
                            throw new Error(e?.message.title ?? 'DictionaryDataProvider getDistinctViewByStore !isCompleted');
                    },signal)
                )
                .catch((e) => {
                    throw new Error(e?.message.text ?? 'getDistinctViewByStore DictionaryDataProvider')
                });
    }

    getDistinctNFvViewByStore(filter: IViewBody, callback?: (data: INFvByStoreDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
            this._coreApiService.requestForMovementRequest
                .then(r => r
                    .getDistinctNFvViewByStore(filter, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e.data.entities, e.data.totalCount);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        else
                            throw new Error(e?.message.title ?? 'DictionaryDataProvider getDistinctViewByStore !isCompleted');
                    },signal)
                )
                .catch((e) => {
                    throw new Error(e?.message.text ?? 'getDistinctViewByStore DictionaryDataProvider')
                });
    }

    getDistinctDosageViewByStore(filter: IViewBody, callback?: (data: IDosageByStoreDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
            this._coreApiService.requestForMovementRequest
                .then(r => r
                    .getDistinctDosageViewByStore(filter, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e.data.entities, e.data.totalCount);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        else
                            throw new Error(e?.message.title ?? 'DictionaryDataProvider getDistinctViewByStore !isCompleted');
                    },signal)
                )
                .catch((e) => {
                    throw new Error(e?.message.text ?? 'getDistinctViewByStore DictionaryDataProvider')
                });
    }

    remains(filter: IDistinctByStoreFilterData, callback?: (quantity: number) => void) {
            this._coreApiService.requestForMovementRequest
                .then(r => r
                    .remains(filter, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e.data);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        else
                            throw new Error(e.message.title);
                    })
                )
                .catch((e) => {
                    throw new Error(e.message.title);
                });
    }
}
